import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { Card, Col, ProgressBar, Row } from "react-bootstrap"
import { ucFirst } from "../../Common/js/generic_functions"
import PlantsPeriodsGraph from "../../Component/Plant/PlantsPeriodsGraph"
import { StarFill, StarHalf, Star } from "react-bootstrap-icons"
import { getCharacTypes } from "../../api/api_charac_type"
import { getObjectIdKey } from "../../Common/js/getObjectIdKey"

class GGPlantId extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
    }

    this.scoreToStars = this.scoreToStars.bind(this)
    this.sortCharacteristics = this.sortCharacteristics.bind(this)
    this.getRelatedEntities = this.getRelatedEntities.bind(this)

    this.dMgr.debug("init_state:", this.state)
  }

  componentDidMount() {
    this.getRelatedEntities()
  }

  getRelatedEntities() {
    // CONFIG ==================================================================================================
    Promise.all([getCharacTypes()]).then((promisesResults) => {
      let [characTypes] = promisesResults
      this.dMgr.debug("getRelatedEntities done")

      this.setState({
        characTypes: characTypes["hydra:member"],
        characTypesAsObject: getObjectIdKey(characTypes["hydra:member"]),
        isReadyToRender: true,
      })
    })
    // /CONFIG =================================================================================================
  }

  sortCharacteristics(characTypes) {
    let sortedCharacteristics = {}

    characTypes.forEach((characType) => {
      sortedCharacteristics[characType.id] = []
    })

    this.props.plant.characteristics.forEach((characteristic) => {
      sortedCharacteristics[characteristic.characType.id].push(characteristic)
    })

    this.dMgr.debug("sortedCharacteristics", sortedCharacteristics)

    return sortedCharacteristics
  }

  scoreToStars(type, score) {
    this.dMgr.debug("scoreToStars:", score)

    let addedStars = 0

    let allStars = []

    for (let i = 0; i < Math.floor(score / 2); i++) {
      allStars.push(<StarFill key={this.props.plant.id + "_" + type + "_" + i} className="margin-right-5 text-warning" />)
      addedStars++
    }

    if (score % 2 === 1) {
      addedStars++
      allStars.push(<StarHalf key={this.props.plant.id + "_" + type + "_" + addedStars} className="margin-right-5 text-warning" />)
    }

    for (let i = addedStars + 1; i <= 5; i++) {
      allStars.push(<Star key={this.props.plant.id + "_" + type + "_" + i} className="margin-right-5 text-warning" />)
    }

    return allStars
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender
    if (Object.keys(this.props.plant).length === 0) {
      toRender = (
        <>
          <br />
          Sélectionnez une plante
        </>
      )
    } else {
      toRender = (
        <Card bg="dark" text="white" className="box-shadow-lvl3">
          <Card.Body>
            <h1 className="text-center">{ucFirst(this.props.plant.name)}</h1>
            <hr />
            {this.props.plant.variety !== undefined && (
              <Row className="margin-top-8">
                <Col md={2} className="text-end">
                  Variété :
                </Col>
                <Col md={4}>{ucFirst(this.props.plant.variety)}</Col>
              </Row>
            )}
            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Nom latin :
              </Col>
              <Col md={4}>{ucFirst(this.props.plant.latin)}</Col>
            </Row>

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Famille :
              </Col>
              <Col md={10}>{this.props.plant.family ? this.props.plant.family.name : "/"}</Col>
            </Row>

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Vernaculaires :
              </Col>
              <Col md={10}>{this.props.plant.vernacularStr || "/"}</Col>
            </Row>

            {this.state.characTypes
              .filter((characType) => characType.id === 3)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}
            {this.state.characTypes
              .filter((characType) => characType.id === 4)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            <hr />

            {this.state.characTypes
              .filter((characType) => characType.id === 1)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            {this.state.characTypes
              .filter((characType) => characType.id === 2)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            {this.state.characTypes
              .filter((characType) => characType.id === 6)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            {this.state.characTypes
              .filter((characType) => characType.id === 7)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            <hr />

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Compagnons :
              </Col>
              <Col md={10}>
                {this.props.plant.fellows
                  .filter((fellow) => fellow.isFriend)
                  .sort((a, b) => a.fellow.name.localeCompare(b.fellow.name))
                  .map((fellow, index, array) => {
                    console.log(fellow.fellow)
                    return (
                      <React.Fragment key={"ennemy_" + fellow.fellow.name}>
                        <a
                          href="#"
                          onClick={() => {
                            window.history.pushState({}, "plant " + fellow.fellow.id, "/plants/" + fellow.fellow.id)
                            this.props.setCurrentPlant(fellow.fellow.id)
                          }}
                        >
                          {fellow.fellow.name}
                        </a>
                        {index < array.length - 1 ? ", " : ""}
                      </React.Fragment>
                    )
                  }) || "/"}
              </Col>
            </Row>
            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Ennemis :
              </Col>
              <Col md={10}>
                {this.props.plant.fellows
                  .filter((fellow) => !fellow.isFriend)
                  .sort((a, b) => a.fellow.name.localeCompare(b.fellow.name))
                  .map((fellow, index, array) => {
                    console.log(fellow.fellow)
                    return (
                      <React.Fragment key={"ennemy_" + fellow.fellow.name}>
                        <a
                          href="#"
                          onClick={() => {
                            window.history.pushState({}, "plant " + fellow.fellow.id, "/plants/" + fellow.fellow.id)
                            this.props.setCurrentPlant(fellow.fellow.id)
                          }}
                        >
                          {fellow.fellow.name}
                        </a>
                        {index < array.length - 1 ? ", " : ""}
                      </React.Fragment>
                    )
                  }) || "/"}
              </Col>
            </Row>
            <hr />

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Besoins soleil :
              </Col>
              <Col md={4}>
                <ProgressBar
                  title={this.props.plant.needSun + "/10"}
                  data-bs-theme="dark"
                  variant="warning"
                  now={this.props.plant.needSun !== -1 ? this.props.plant.needSun * 10 : 0}
                  className="margin-top-5"
                />
              </Col>
              <Col md={2} className="text-end">
                Besoins eau :
              </Col>
              <Col md={4}>
                <ProgressBar
                  title={this.props.plant.needWater + "/10"}
                  data-bs-theme="dark"
                  variant="primary"
                  now={this.props.plant.needWater !== -1 ? this.props.plant.needWater * 10 : 0}
                  className="margin-top-5"
                />
              </Col>
            </Row>
            <Row className="margin-top-8">
              {this.props.plant.productivity > -1 && (
                <>
                  <Col md={2} className="text-end">
                    Productivité :
                  </Col>
                  <Col md={2}>{this.scoreToStars("productivity", this.props.plant.productivity)}</Col>
                </>
              )}

              {this.props.plant.growth > -1 && (
                <>
                  <Col md={2} className="text-end">
                    Croissance :
                  </Col>
                  <Col md={2}>{this.scoreToStars("growth", this.props.plant.growth)}</Col>
                </>
              )}

              {this.props.plant.foliage > -1 && (
                <>
                  <Col md={2} className="text-end">
                    Feuillage :
                  </Col>
                  <Col md={2}>{this.scoreToStars("foliage", this.props.plant.foliage)}</Col>
                </>
              )}

              {this.props.plant.heightPlant > -1 && (
                <>
                  <Col md={2} className="text-end">
                    Hauteur :
                  </Col>
                  <Col md={2}>{this.scoreToStars("heightPlant", this.props.plant.heightPlant)}</Col>
                </>
              )}

              {this.props.plant.sizeProduct > -1 && (
                <>
                  <Col md={2} className="text-end">
                    Taille produit :
                  </Col>
                  <Col md={2}>{this.scoreToStars("growth", this.props.plant.sizeProduct)}</Col>
                </>
              )}
            </Row>
            <hr />

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Périodes :
              </Col>
            </Row>
            <Row className="margin-top-8">
              <Col md={12} className="text-center">
                <PlantsPeriodsGraph key={"graphPeriod-" + this.props.plant.id} plants={[this.props.plant]} displayPeriodNumbers={false} />
              </Col>
            </Row>
            <hr />

            <Row className="margin-top-8">
              <Col md={2} className="text-end">
                Profondeur semis :{" "}
              </Col>
              <Col md={2}>{this.props.plant.seedingDepth > -1 ? this.props.plant.seedingDepth + " mm" : "/"}</Col>
              <Col md={2} className="text-end">
                Distance plants :{" "}
              </Col>
              <Col md={2}>{this.props.plant.distanceBetweenPlants > -1 ? this.props.plant.distanceBetweenPlants + " cm" : "/"}</Col>
              <Col md={2} className="text-end">
                Distance rangées :{" "}
              </Col>
              <Col md={2}>{this.props.plant.distanceBetweenRows > -1 ? this.props.plant.distanceBetweenRows + " cm" : "/"}</Col>
            </Row>

            {this.state.characTypes
              .filter((characType) => characType.id === 5)
              .map((characType) => {
                return (
                  <Row className="margin-top-8" key={"row_characType_" + characType.id}>
                    <Col md={2} className="text-end">
                      {characType.name} :
                    </Col>
                    <Col md={10}>
                      {this.props.plant.characteristics
                        .filter((characteristic) => characteristic.characType.id === characType.id)
                        .map((characteristic) => {
                          return characteristic.name
                        })
                        .join(", ") || "/"}
                    </Col>
                  </Row>
                )
              })}

            <hr />

            {this.props.plant.methodSeeding > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Semis : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodSeeding.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.methodPlanting > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Plantation : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodPlanting.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.methodGrowing > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Culture : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodGrowing.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.methodHarvesting > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Récolte : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodHarvesting.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.methodConservation > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Conservation : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodConservation.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.methodUtilization > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Utilisation test: </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.methodUtilization.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            {this.props.plant.importantNote > 0 && (
              <Row className="margin-top-8">
                <Col md={2}>Autres : </Col>
                <Col md={10}>
                  <ul>
                    {this.props.plant.importantNote.map((element, index) => (
                      <li key={index}>{element}</li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}
          </Card.Body>
        </Card>
      )
    }

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(GGPlantId)
